"use client";

import React from "react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const teamMembers = [{
  id: 1,
  name: "Hledáme právě vás!",
  role: "Smyslná & Elegantní",
  image: "https://wired-magpie.10web.cloud/wp-content/uploads/2026/05/Screenshot_3.jpg?v=tum0k4y0g0p",
  isOnline: true
}, {
  id: 2,
  name: "Přidejte se k nám",
  role: "Divoká & Nespoutaná",
  image: "https://wired-magpie.10web.cloud/wp-content/uploads/2026/05/Screenshot_3.jpg?v=ge2v9efecem",
  isOnline: false
}, {
  id: 3,
  name: "Nová tvář SENSU",
  role: "Něžná & Pečující",
  image: "https://wired-magpie.10web.cloud/wp-content/uploads/2026/05/Screenshot_3.jpg?v=rfx5yz8b1dj",
  isOnline: true
}];
export default function HamariTeam() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223823" id="naše-bohyně-v-salónu" className="bg-background text-foreground py-24 md:py-32 overflow-hidden">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl">
        <div ref={ref} className={`mb-16 md:mb-24 text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-4xl md:text-6xl font-bold mb-4 tracking-widest uppercase bg-linear-to-r from-[#d4af37] via-[#f9e498] to-[#d4af37] bg-clip-text text-transparent drop-shadow-[0_0_12px_rgba(249,228,152,0.4)] animate-pulse">
            Naše Bohyně
          </h2>
          <p className="font-sans text-muted-foreground text-lg md:text-xl max-w-2xl mx-auto tracking-wide mb-10">Hledáme právě vás. Staňte se součástí týmu SENSU a pomozte nám vytvářet nezapomenutelné rituály klidu a harmonie. Rozšiřujeme náš tým o nové kolegyně, které chtějí růst v luxusním a profesionálním prostředí.</p>
          
          <div className="flex justify-center">
            <Button asChild className="bg-black border border-primary/50 text-primary hover:bg-primary hover:text-black transition-all duration-500 px-10 py-6 rounded-full uppercase tracking-[0.2em] font-sans text-sm shadow-[0_0_20px_rgba(212,175,55,0.1)] hover:shadow-[0_0_30px_rgba(212,175,55,0.2)]">
              <Link to="/ContactPage">
                Přidej se k nám
              </Link>
            </Button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {teamMembers.map((member, i) => <div key={member.id} data-index={i} className={`group flex flex-col items-center text-center transition-all duration-1000 ease-out delay-${i * 200} ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
              <div className="relative w-full aspect-[3/4] overflow-hidden mb-6 bg-muted rounded-none border border-primary/20">
                <img src={member.image} data-wvc-srcset={`${member.image}-wvc-srcset`} data-wvc-sizes={`${member.image}-wvc-sizes`} alt={member.name} loading="lazy" className="w-full h-full object-cover grayscale brightness-75 contrast-110 transition-transform duration-1000 ease-out group-hover:scale-105 group-hover:grayscale-0 group-hover:brightness-100" />
                <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-transparent to-transparent opacity-60" />
                
                <div className="absolute bottom-0 left-0 right-0 p-6 backdrop-blur-md bg-black/40 border-t border-primary/20 translate-y-2 group-hover:translate-y-0 transition-transform duration-500">
                  <div className="flex items-center justify-center gap-2 mb-1">
                    {member.isOnline && <span className="relative flex h-2 w-2">
                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
                        <span className="relative inline-flex rounded-full h-2 w-2 bg-primary"></span>
                      </span>}
                    <h3 className="font-serif text-2xl font-medium text-foreground tracking-wide">
                      {member.name}
                    </h3>
                  </div>
                  <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-100">
                    <Badge variant="outline" className="px-0 border-none text-[10px] font-sans uppercase tracking-[0.3em] text-primary">
                      {member.role}
                    </Badge>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}